var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79492 3.5C10.5906 3.5 11.3536 3.81607 11.9162 4.37868C12.4789 4.94129 12.7949 5.70435 12.7949 6.5C12.7949 7.29565 12.4789 8.05871 11.9162 8.62132C11.3536 9.18393 10.5906 9.5 9.79492 9.5C8.99927 9.5 8.23621 9.18393 7.6736 8.62132C7.11099 8.05871 6.79492 7.29565 6.79492 6.5C6.79492 5.70435 7.11099 4.94129 7.6736 4.37868C8.23621 3.81607 8.99927 3.5 9.79492 3.5ZM9.79492 11C13.1099 11 15.7949 12.3425 15.7949 14V15.5H3.79492V14C3.79492 12.3425 6.47992 11 9.79492 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ac0ae98cf70a7e080f11f4eb5cc68931.svg";
export { ForwardRef as ReactComponent };